import * as actionTypes from "./actionTypes";
import { updateFieldWarning } from "./FieldValidationAction";
import { getWarningDetail } from "../api/getEntrySummaryData";

export function initializeValuesShipmentLevel(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_SHIPMENT_LEVEL,
    payload,
  };
}
export function initializeValuesTransactionNo(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_TRANSACTION_NO,
    payload,
  };
}
export function initializeValuesCargoControlNo(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_CARGO_CONTROL_NO,
    payload,
  };
}

export function initializeShipmentNotes(payload, notesLoaded) {
  return {
    type: actionTypes.INITIALIZE_VALUES_NOTES,
    payload,
    notesLoaded,
  };
}

export function initializeValuesImporter(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_IMPORTER,
    payload,
  };
}
export function initializeValuesSubHrd(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_SUBHRD,
    payload,
  };
}
export function initializeValuesDescriptionOfInvoice(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_DESCRIPTION_OF_INVOICE,
    payload,
  };
}
export function initializeValuesDescriptionOfMerchandise(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_DESCRIPTION_OF_MERCHANDISE,
    payload,
  };
}

export function initializeValuesDeclarationSection(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_DECLARATION_SECTION,
    payload,
  };
}

export function initializeValuesCargoSection(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_CARGO_SECTION,
    payload,
  };
}
export function initializeValuesTotalsSection(payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_TOTALS_SECTION,
    payload,
  };
}

export function intializeWarnings() {
  return {
    type: actionTypes.INITIALIZE_WARNINGS,
  };
}

export function initializeValuesFieldValidation(payload) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.INITIALIZE_VALUES_FIELD_VALIDATION,
      payload,
    });
    payload.fields.forEach((fieldItem) => {
      if (fieldItem.ApplicableWarningCode) {
        getWarningDetail(fieldItem.ApplicableWarningCode).then((response) => {
          dispatch(updateFieldWarning(response.data.eventMessage.warnings[0]));
        });
      }
    });
  };
}

export function initializeDropDowns(payload) {
  return {
    type: actionTypes.INITIALIZE_DROPDOWNS,
    payload,
  };
}

export function initializeShipId(payload) {
  return {
    type: actionTypes.INITIALIZE_SHIPID,
    payload,
  };
}

export function setFormLoaded(formLoaded, shipmentId, userType, error = null) {
  return {
    type: actionTypes.FORM_LOADED,
    formLoaded,
    shipmentId,
    userType,
    error,
  };
}

export function setFormValues(
  penClicked,
  setINPUTID,
  newValue,
  fieldName,
  rbCounterID
) {
  return {
    type: actionTypes.FORM_VALUES,
    penClicked,
    setINPUTID,
    newValue,
    fieldName,
    rbCounterID,
  };
}

export function setErrorMessage(errorMessage) {
  return {
    type: actionTypes.SET_ERROR_MESSAGE,
    errorMessage,
  };
}

export function setAnyFormValue(valueName, value) {
  return {
    type: actionTypes.SET_ANY_FORM_VALUES,
    valueName,
    value,
  };
}

export function initializeTC(lineItemIndex, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_TC(lineItemIndex),
    payload,
  };
}
export function initializeECCC(lineItemIndex, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_ECCC(lineItemIndex),
    payload,
  };
}
export function initializeECCCFlag(payload) {
  return {
    type: actionTypes.INITIALIZE_ECCC_FLAG,
    payload,
  };
}

export function initializeInvoiceECCC(lineItemIndex, payload) {
  return {
    type: actionTypes.INITIALIZE_INVOICE_VALUES_ECCC(lineItemIndex),
    payload,
  };
}

export function initializeCFIA(lineItemIndex, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_CFIA(lineItemIndex),
    payload,
  };
}
export function initializeCNSC(lineItemIndex, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_CNSC(lineItemIndex),
    payload,
  };
}
export function initializeCFIAPayor(lineItemIndex, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_CFIA_PAYOR(lineItemIndex),
    payload,
  };
}

export function initializeNRCan(lineItemIndex, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_NRCAN(lineItemIndex),
    payload,
  };
}
export function initializeGAC(lineItemIndex, payload) {
  return {
    type: actionTypes.INITIALIZE_VALUES_GAC(lineItemIndex),
    payload,
  };
}

export function initializeWarningsOnHeaderTab(payload, parentShipmentId, formType='', isGoodRealesed) {
  return {
    type: actionTypes.INIT_HEADER_TAB_WARNINGS,
    rest: payload,
    parentShipmentId,
    formType,
    isGoodRealesed
  };
}

export function initializeWarningsOnPartiesTab(payload) {
  return {
    type: actionTypes.INIT_PARTIES_TAB_WARNINGS,
    rest: payload,
  };
}

export function initializeWarningsOnInvoiceTab(payload) {
  return {
    type: actionTypes.INIT_INVOICE_TAB_WARNINGS,
    rest: payload,
  };
}

export function initializeWarningsOnLineItemTab(payload) {
  return {
    type: actionTypes.INIT_LINE_TAB_WARNINGS,
    rest: payload,
  };
}
